import isUndefined from 'lodash/isUndefined';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { getLocaleStore } from '@/i18n/index';
import { deleteExtraInfo } from '@/utils/layer-kit';
import {
    IExportBehavior,
    IGroupLayerProps,
    ILayerBehavior,
    ILayerProps,
    IRenderLayerExtraProps,
    ISize,
    LayerType,
} from '@/version-types';
import GroupLayer from './views/group-layer';

function getBehavior(identity: string) {
    const layerBehavior: ILayerBehavior = {
        render(layer: ILayerProps, extraProps: IRenderLayerExtraProps) {
            return <GroupLayer layer={layer} {...extraProps} />;
        },

        async getResultCanvasAsync(layer: ILayerProps, resultSize: ISize): Promise<HTMLCanvasElement | undefined> {
            return;
        },
        onBeforeAddOrUpdate(layer: ILayerProps) {
            if (isUndefined(layer.data) || isUndefined((layer.data as IGroupLayerProps)?.isExtraGroup)) {
                layer.data = {
                    ...layer.data,
                    isExtraGroup: false,
                } as IGroupLayerProps;
            }
        },
        async onBeforeSaveAsync(layer: ILayerProps, isAutoSave?: boolean) {
            deleteExtraInfo(layer);
            delete (layer as any).data.isExtraGroup;
            delete (layer as any).data.isVip;
        },
        getMenuOverlapName(layer: ILayerProps) {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.group);
        },
        getMenuOverlapIcon(layer: ILayerProps) {
            return (
                <div className="l-layer__icon">
                    <IconFont name="Folder" fontSize={16} />
                </div>
            );
        },
        getScaleIsNeedLimitSize() {
            return true;
        },
    };
    return layerBehavior;
}

const exportBehavior: IExportBehavior = {
    layerType: LayerType.GROUP_LAYER,
    getBehavior,
};

export default exportBehavior;
